import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import '../DashboardIntervenant/DashboardIntervenant.css';

// Import des icônes MUI
import {
  WavingHandOutlined as WaveIcon,
  TrendingUp as TrendIcon,
} from '@mui/icons-material';

const DashboardPraticien = () => {
  const { user } = useAuth();
  const [info, setInfo] = useState(null);
  const storageUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(
          `${storageUrl}/praticien/dashboard/summary-stats`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setInfo(res.data.data);
      } catch (err) {
        console.error("Erreur lors de la récupération des stats du praticien", err);
      }
    };
    if (user) fetchStats();
  }, [user, storageUrl]);

  if (!user) return null;

  return (
    <div className="dashboard-wrapper">
      <main className="dashboard-content">
        {/* --- BANNER --- */}
        <div className="dashboard-banner">
          <div className="banner-info">
            <div className="banner-title">
              <WaveIcon className="wave-icon" />
              <h1>Bienvenue, Dr./Praticien {user.prenom} !</h1>
            </div>
            <p>Tableau de bord Praticien - Espace en cours de configuration.</p>
          </div>
          <TrendIcon className="banner-bg-icon" />
        </div>

        {/* --- CONTENU VIDE / PERSONNALISABLE --- */}
        <div className="dashboard-main-grid" style={{ gridTemplateColumns: '1fr' }}>
          <div className="content-card" style={{ padding: '40px', textAlign: 'center' }}>
            <h3>Espace Praticien</h3>
            <p style={{ color: '#666', marginTop: '10px' }}>
              Ici, vous pourrez ajouter vos widgets personnalisés, la liste de vos patients, ou vos plannings de consultation.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default DashboardPraticien;